import { render, staticRenderFns } from "./allocationOrderManage.vue?vue&type=template&id=0219580d&scoped=true"
import script from "./allocationOrderManage.vue?vue&type=script&lang=js"
export * from "./allocationOrderManage.vue?vue&type=script&lang=js"
import style0 from "./allocationOrderManage.vue?vue&type=style&index=0&id=0219580d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0219580d",
  null
  
)

export default component.exports